var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "96ra7wauya",
    d: "M0 0h14v14.61H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l7v3k101cc",
    d: "M0 0h1.405v2.77H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "yfbe0f3tge",
    d: "M0 0h1.405v2.77H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.39)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "6l10l1x00b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#96ra7wauya"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.96 13.066a.45.45 0 0 1-.44.457H1.48a.449.449 0 0 1-.44-.457V3.769h11.92v9.297zM12.52 0h-1.304v.646c0 .644-.502 1.168-1.12 1.168-.616 0-1.118-.524-1.118-1.168V0H5.022v.646c0 .644-.502 1.168-1.119 1.168S2.784 1.29 2.784.646V0H1.48C.664 0 0 .693 0 1.544v11.522c0 .851.664 1.544 1.48 1.544h11.04c.816 0 1.48-.693 1.48-1.544V1.544C14 .693 13.336 0 12.52 0z",
    fill: "currentColor",
    mask: "url(#6l10l1x00b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7ed09a3qdd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#l7v3k101cc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.703 2.77c.387 0 .702-.33.702-.733V.733C1.405.33 1.09 0 .703 0 .315 0 0 .329 0 .733v1.304c0 .404.315.733.703.733",
    fill: "currentColor",
    mask: "url(#7ed09a3qdd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.394)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g16wmxlhjf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#yfbe0f3tge"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.703 2.77c.387 0 .702-.33.702-.733V.733C1.405.33 1.09 0 .703 0 .315 0 0 .329 0 .733v1.304c0 .404.315.733.703.733",
    fill: "currentColor",
    mask: "url(#g16wmxlhjf)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.379 11.069h2.385a.139.139 0 0 0 .136-.142V9.19a.139.139 0 0 0-.136-.142H9.38a.139.139 0 0 0-.136.142v1.737c0 .078.06.142.136.142M5.807 11.069h2.386a.139.139 0 0 0 .136-.142V9.19a.139.139 0 0 0-.136-.142H5.807a.139.139 0 0 0-.136.142v1.737c0 .078.061.142.136.142M2.236 11.069H4.62a.139.139 0 0 0 .136-.142V9.19a.139.139 0 0 0-.136-.142H2.236a.139.139 0 0 0-.136.142v1.737c0 .078.06.142.136.142M9.379 13.784h2.385a.139.139 0 0 0 .136-.142v-1.736a.139.139 0 0 0-.136-.142H9.38a.139.139 0 0 0-.136.142v1.736c0 .079.06.142.136.142M5.807 13.784h2.386a.139.139 0 0 0 .136-.142v-1.736a.139.139 0 0 0-.136-.142H5.807a.139.139 0 0 0-.136.142v1.736c0 .079.061.142.136.142M2.236 13.784H4.62a.139.139 0 0 0 .136-.142v-1.736a.139.139 0 0 0-.136-.142H2.236a.139.139 0 0 0-.136.142v1.736c0 .079.06.142.136.142M9.379 8.353h2.385a.139.139 0 0 0 .136-.142V6.474a.139.139 0 0 0-.136-.141H9.38a.139.139 0 0 0-.136.141v1.737c0 .079.06.142.136.142M5.807 8.353h2.386a.139.139 0 0 0 .136-.142V6.474a.139.139 0 0 0-.136-.141H5.807a.139.139 0 0 0-.136.141v1.737c0 .079.061.142.136.142",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.faf039450d709cb4b6b59ef6180c953b.svg";
export { ForwardRef as ReactComponent };